module.exports = __webpack_public_path__ + "static/media/instruction-photo-two.fdd27e5a.png";